<template>
    <TemplateTable
            :title="$t('menu.returns')"
            name="ordersReturns"
            :url="$listRoutes.ordersReturns"
            :table="ordersReturns"
            :filters="ordersReturnsFilters"
            :fields="fields"
    />
</template>

<script>
import { mapState } from 'vuex';
import TemplateTable from '@/components/templates/TemplateTable';
export default {
    name: 'ReturnsPage',
    components: {TemplateTable},
    data() {
        return {
            fields: [
                {key: 'id', type: 'eye', route: 'orders-return', size: 'xs'},
                {key: 'client', type: 'client', size: 'l'},
                {key: 'user', type: 'userEmail', size: 'xl'},
                {key: 'shopifyTitle', size: 'xxl'},
                {key: 'amountCredit', type: 'formatPrice'},
                {key: 'returnDate', type: 'date'},
                {key: 'sourceAchat', type: 'tagType'},
                {key: 'sourceVente', type: 'tagType'},
                {key: 'condition.name', translationKey: 'condition', size: 'm'},
                {key: 'shopifyPriceNoTax', type: 'formatPrice'},
                {key: 'shopifyPriceTax', type: 'formatPrice'},
                {key: 'shopifyPriceWithTax', type: 'formatPrice'},
                {key: 'shopifyId', type: 'shopifyProduct', size: 'm'},
                {key: 'shopifyOrderId', type: 'shopifyOrder', size: 'm'},
                {key: 'status', type: 'tagType', size: 'm'},
                //{key: 'source'},
                {key: 'tradeinCountry'},
                {key: 'saleCountry'}
            ]
        }
    },
    computed: {
        ...mapState(['ordersReturns', 'ordersReturnsFilters'])
    }
}
</script>